export default __webpack_public_path__ + "static/media/ing.8c8f078c.pdf";